import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';

import { CopyToClipboard, getMetadata } from '@sheerid/jslib';

import { getQueryParamsByName, redirect } from '../../lib/utils/browser';

import { successRedirectUrl } from '../../index';

const StepSuccess = () => {
    let trackingId = '';
    if (!getQueryParamsByName('trackingIdentifier') && getQueryParamsByName('verificationId')) {
        trackingId = 'Error: Check your email';
    } else {
        trackingId = (getQueryParamsByName('trackingIdentifier') || getMetadata()?.trackingIdentifier).toString();
    }
    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage
                        id="step.success.subtitle"
                        defaultMessage={
                            `Here is your personal coupon code.
                        It is unique to you and can only be used once.`
                        }
                    />
                </div>
            </div>

            <div className="sid-reward-code sid-l-space-top-lg sid-h-jumbo-text sid-l-horz-center">
                {trackingId}
            </div>

            <div className="sid-l-space-top-md sid-h-bold-text sid-l-horz-center">
                <CopyToClipboard
                    textToCopy={`${trackingId}`}
                    notificationText={<FormattedHTMLMessage id="copied" defaultMessage="Copied" />}
                >
                    <FormattedHTMLMessage id="step.success.copyCouponCode" defaultMessage="Copy Coupon code" />
                </CopyToClipboard>
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg">
                <FormattedHTMLMessage
                    id="step.success.emailNotification"
                    defaultMessage={`
                    We have emailed you a copy so you can use your code now or later. Look for the email from verify@sheerid.com
                `}
                />
            </div>
            <div className="sid-submit sid-l-space-top-md">
                <button
                    type="button"
                    onClick={() => redirect(successRedirectUrl)}
                    className="sid-btn sid-btn--dark"
                >
                    <FormattedHTMLMessage
                        id="step.success.redirectButtonText"
                        defaultMessage="CONTINUE"
                    />
                </button>
            </div>
            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedMessage id="companyName" defaultMessage="{Company}">
                    {companyName => (
                        <FormattedHTMLMessage
                            id="step.success.verificationOnly"
                            defaultMessage={`
                                SheerID handles verification only.
                                Now that you've been approved, please direct all questions about the
                                promotion terms and/or code use to {companyName} customer service.
                            `}
                            values={{ companyName }}
                        />
                    )}
                </FormattedMessage>
            </div>
        </div>
    );
};


export const StepSuccessComponent = StepSuccess;
